import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Layout from "../components/layout/Layout";
import api from "../lib/api";
import useSeo from "../hooks/useSeo";
import { ChevronRight, ArrowLeft, ArrowRight } from "lucide-react";

export default function OpeningGuideStep() {
  const { slug } = useParams();
  const [step, setStep] = useState(null);
  const [allSteps, setAllSteps] = useState([]);

  useEffect(() => {
    api.get(`/opening-guide/${slug}`).then((r) => setStep(r.data));
    api.get("/opening-guide").then((r) => setAllSteps(r.data || []));
  }, [slug]);

  useSeo({
    title: step ? step.seo_title || `${step.title_tr} — Otel Pro` : "Otel Pro",
    description: step?.seo_description || step?.summary,
    image: step?.image,
  });

  if (!step) return <Layout><div className="section-pad container-site">Yükleniyor...</div></Layout>;

  const currentIdx = allSteps.findIndex((s) => s.slug === slug);
  const prev = currentIdx > 0 ? allSteps[currentIdx - 1] : null;
  const next = currentIdx >= 0 && currentIdx < allSteps.length - 1 ? allSteps[currentIdx + 1] : null;

  return (
    <Layout>
      <div className="bg-softbg">
        <div className="container-site py-5 flex items-center gap-2 text-xs text-gray-500">
          <Link to="/" className="hover:text-navy">Ana Sayfa</Link>
          <ChevronRight size={12} />
          <Link to="/acilis-rehberi" className="hover:text-navy">Açılış Rehberi</Link>
          <ChevronRight size={12} />
          <span className="text-navy font-medium">{step.title_tr}</span>
        </div>
      </div>

      <section
        className="relative bg-navy text-white py-20"
        style={step.image ? { backgroundImage: `linear-gradient(rgba(8,17,29,0.8), rgba(8,17,29,0.7)), url(${step.image})`, backgroundSize: "cover", backgroundPosition: "center" } : {}}
      >
        <div className="container-site max-w-3xl">
          <p className="accent-script text-gold text-2xl mb-2">Adım {currentIdx + 1}</p>
          <h1 className="heading-serif text-3xl md:text-5xl font-semibold leading-tight">{step.title_tr}</h1>
          <p className="text-white/75 mt-4">{step.summary}</p>
        </div>
      </section>

      <section className="section-pad">
        <div className="container-site max-w-3xl">
          <div className="prose prose-lg max-w-none" dangerouslySetInnerHTML={{ __html: step.content }} />

          <div className="mt-12 p-7 rounded-xl bg-navy text-white text-center">
            <p className="accent-script text-gold text-xl mb-1">Bu Adım İçin</p>
            <h3 className="heading-serif text-2xl font-semibold mb-3">Uzman Danışmanlık Alın</h3>
            <p className="text-white/70 text-sm mb-5">
              Bu aşamada ihtiyacınız olan ekipmanlar ve stratejik kararlar için uzmanlarımız yanınızda.
            </p>
            <Link to="/iletisim" className="btn-gold" data-testid="guide-step-cta">
              Ücretsiz Danışmanlık <ArrowRight size={16} />
            </Link>
          </div>

          <div className="mt-10 flex items-center justify-between">
            {prev ? (
              <Link to={`/acilis-rehberi/${prev.slug}`} className="text-navy hover:text-gold flex items-center gap-1.5" data-testid="guide-step-prev">
                <ArrowLeft size={14} /> {prev.title_tr}
              </Link>
            ) : <span />}
            {next && (
              <Link to={`/acilis-rehberi/${next.slug}`} className="text-navy hover:text-gold flex items-center gap-1.5" data-testid="guide-step-next">
                {next.title_tr} <ArrowRight size={14} />
              </Link>
            )}
          </div>
        </div>
      </section>
    </Layout>
  );
}
